import React from 'react';
import styled from 'styled-components';

import { PaginationI } from '~src/interfaces/pagination.interface';
import {useTranslation} from "react-i18next";

const ItemsAmountBox = styled.div<{ $hide: boolean }>`
  display: flex;
  align-items: center;
  font-size: 0.8rem;
  color: ${({ theme }) => theme.baseBlue.a6};
  white-space: nowrap;
  ${({ $hide }) => ($hide ? 'visibility: hidden' : '')};
`;

interface Props {
  pagination: PaginationI;
  onePageKey: string;
  multyPageKey: string;
}

const getOnPageCount = (page: number, count: number, perPage: number): string => {
  const countStart = page * perPage - perPage;
  const fromCount = countStart || 1;
  const toCount = count < perPage ? countStart + count : page * perPage;

  return `${fromCount} - ${toCount}`;
};

const ItemsAmount: React.FC<Props> = React.memo(
  function ItemsAmount({ pagination: { page, total, count, per_page }, onePageKey, multyPageKey }) {
    const { t } = useTranslation();
    let countTxtKey = onePageKey;
    const tConf: { count: number; onPage?: string } = { count: total };
    if (total > per_page) {
      countTxtKey = multyPageKey;
      tConf.onPage = getOnPageCount(page, count, per_page);
    }
    return (
      <ItemsAmountBox $hide={!count} data-translation={countTxtKey}>
        {t(countTxtKey, tConf)}
      </ItemsAmountBox>
    );
  },
);

export default ItemsAmount;
